"use client"

import * as React from "react"
import * as TooltipPrimitive from "@radix-ui/react-tooltip"
import { cn } from "@/lib/utils"

const TooltipProvider = TooltipPrimitive.Provider

const Tooltip = TooltipPrimitive.Root

const TooltipTrigger = TooltipPrimitive.Trigger

function TooltipContent({
  className,
  sideOffset = 6,
  ref,
  children,
  ...props
}: React.ComponentPropsWithoutRef<typeof TooltipPrimitive.Content> & {
  ref?: React.Ref<React.ElementRef<typeof TooltipPrimitive.Content>>
}) {
  return (
    <TooltipPrimitive.Portal>
      <TooltipPrimitive.Content
        ref={ref}
        sideOffset={sideOffset}
        className={cn(
          // §02.5 + §17.1: ink fill (never surface/border like a card — a
          // tooltip is a solid ink chip with a caret, not a bordered panel),
          // radius-0 (read, not pressed or grabbed).
          "z-50 max-w-[280px] overflow-hidden rounded-[var(--ls-radius-0)] bg-[var(--tls-fg-strong)] px-[10px] py-[7px] text-[0.78125rem] font-semibold leading-[1.35] text-[var(--tls-canvas)]",
          "origin-[var(--radix-tooltip-content-transform-origin)] opacity-100 [transform:scale(1)] transition-[opacity,transform] duration-[var(--motion-duration-fast)] ease-[var(--motion-ease-emphasis)]",
          "starting:opacity-0 motion-safe:starting:[transform:scale(0.97)] data-[state=closed]:opacity-0 motion-safe:data-[state=closed]:[transform:scale(0.97)] data-[state=instant-open]:duration-0",
          className
        )}
        {...props}
      >
        {children}
        <TooltipPrimitive.Arrow
          width={10}
          height={5}
          className="fill-[var(--tls-fg-strong)]"
        />
      </TooltipPrimitive.Content>
    </TooltipPrimitive.Portal>
  )
}
TooltipContent.displayName = TooltipPrimitive.Content.displayName

export { Tooltip, TooltipTrigger, TooltipContent, TooltipProvider }
